import { DepartmentDto, OperationAvailabilityDto } from "../../autogen/bff-api";
import { showsContractDepartment, showsProjectDepartment } from "./departmentVisibility";

type OrgWithDepartments = { departments?: DepartmentDto[] };

const CREATE_SOURCING_EVENT = "CreateSourcingEvent";
const CREATE_PROJECT = "CreateProject";
const CREATE_CONTRACT = "CreateContract";
const VIEW_CONTRACT = "ViewContract";

const allows = (operations: OperationAvailabilityDto[] | undefined, operation: string): boolean =>
  operations?.some((o) => o.operation === operation && o.allowed) ?? false;

const departmentsAllowing = (org: OrgWithDepartments, operation: string): DepartmentDto[] =>
  (org.departments ?? []).filter((d) => allows(d.operations, operation));

// A hidden picker still has to supply a department: the BFF requires one on every entity.
const initialDepartmentId = (org: OrgWithDepartments, operation: string, showsPicker: boolean): string | undefined => {
  const creatable = departmentsAllowing(org, operation);
  if (!showsPicker) return (creatable.find((d) => d.isDefault) ?? creatable[0])?.id;
  return creatable.length === 1 ? creatable[0].id : undefined;
};

export const someDepartmentAllowsViewingContracts = (org: OrgWithDepartments): boolean =>
  departmentsAllowing(org, VIEW_CONTRACT).length > 0;

export const departmentsForNewEvent = (org: OrgWithDepartments): DepartmentDto[] =>
  departmentsAllowing(org, CREATE_SOURCING_EVENT);

export const projectDepartmentOptions = (org: OrgWithDepartments): DepartmentDto[] =>
  departmentsAllowing(org, CREATE_PROJECT);

export const contractDepartmentOptions = (org: OrgWithDepartments): DepartmentDto[] =>
  departmentsAllowing(org, CREATE_CONTRACT);

export const initialProjectDepartmentId = (org: OrgWithDepartments): string | undefined =>
  initialDepartmentId(org, CREATE_PROJECT, showsProjectDepartment(org));

export const initialContractDepartmentId = (org: OrgWithDepartments): string | undefined =>
  initialDepartmentId(org, CREATE_CONTRACT, showsContractDepartment(org));

export const departmentName = (org: OrgWithDepartments, departmentId: string | null | undefined) =>
  departmentId ? (org.departments ?? []).find((d) => d.id === departmentId)?.name : undefined;
